import React, {useContext, useEffect, useState} from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Main from "../../layout/Main";
import Dashboard from "./Dashboard";
import Alerta from "../modal/Alerta";
import AuthContext from '../../context/authentication/authContext';
import StudentContext from '../../context/student/studentContext';
import TeacherContext from '../../context/teacher/teacherContext';
import loader from "../../img/ajax-loader.gif";

function Mentoring() {

    const authToken = useContext(AuthContext);
    const { usuarioAutenticado, user } = authToken;

    const studentContext = useContext(StudentContext);
    const { matchFromStudent } = studentContext;

    const teacherContext = useContext(TeacherContext);
    const { matchFromTeacher } = teacherContext;


    useEffect(() => {
        usuarioAutenticado();
        matchFromStudent();
        matchFromTeacher();
        // eslint-disable-next-line
    }, [])

    const [ showAlerta, setShowAlerta] = useState(true);

    return (
    <>
        <div className="container-fluid">
            { !user ? (<
                Alerta isOpen={showAlerta} onClose={() => setShowAlerta(false)} infoMsg={<label><img src={loader} alt="loader" /> Procesando...</label>} />
            ) : (
                <Router>
                    {   user.profile === "Manager" && ( 
                            <Main />
                        )
                    }
                    {   user.profile !== "Manager" && ( 
                            <Dashboard />
                        )
                    }
                    
                </Router>
            ) }
        </div>
    </>
    );
}

export default Mentoring;